import { render } from "./CreateProcedure.vue?vue&type=template&id=3365588c&scoped=true"
import script from "./CreateProcedure.vue?vue&type=script&lang=js"
export * from "./CreateProcedure.vue?vue&type=script&lang=js"

import "./CreateProcedure.vue?vue&type=style&index=0&id=3365588c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3365588c"]])

export default __exports__